import { createStore, combineReducers, compose, applyMiddleware } from 'redux'
import { persistStore, persistReducer, createTransform } from 'redux-persist'
import storage from 'redux-persist/lib/storage'

import thunk from 'redux-thunk'

import profile from './reducers/profile'
import snackbar from './reducers/snackbar'
import backdrop from './reducers/backdrop'
import utilities from './reducers/utilities'
import setting from './reducers/setting'

const STORE_VERSION = '1.1.4'

const rootReducer = combineReducers({
  profile,
  snackbar,
  backdrop,
  utilities,
  setting
})

const omitClockSkew = createTransform(
  (inboundState) => {
    if (!inboundState || typeof inboundState !== 'object') return inboundState
    const { clockSkew, ...rest } = inboundState
    return rest
  },
  (outboundState) => {
    if (!outboundState || typeof outboundState !== 'object') return outboundState
    const { clockSkew, ...rest } = outboundState
    return rest
  },
  { whitelist: ['utilities'] }
)

const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['profile', 'setting', 'utilities'],
  transforms: [omitClockSkew],
  version: STORE_VERSION,
  migrate: (state) => {
    if (state && state._persist && state._persist.version !== STORE_VERSION) {
      state.utilities.update = true
      console.info('NEW STORE DETECTED')
    }
    return Promise.resolve(state)
  }
}

const persistedReducer = persistReducer(persistConfig, rootReducer)

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose

const configureStore = () => {
  let store = createStore(persistedReducer, composeEnhancers(applyMiddleware(thunk)))
  let persistor = persistStore(store)
  return { store, persistor }
};

export default configureStore